/**
 * Canonical API origin for fetch and axios clients.
 * CRA inlines REACT_APP_* at build/start time (.env.development.local is gitignored).
 * Production builds without that env keep https://legroslovakia.sk.
 */

export const PRODUCTION_API_BASE_URL = 'https://legroslovakia.sk';

export function resolveApiBaseUrl(raw = process.env.REACT_APP_API_BASE_URL) {
  if (raw == null) {
    return PRODUCTION_API_BASE_URL;
  }
  const trimmed = String(raw).trim().replace(/\/+$/, '');
  return trimmed || PRODUCTION_API_BASE_URL;
}

export function apiRequestUrl(path, base = resolveApiBaseUrl()) {
  const origin = resolveApiBaseUrl(base);
  const suffix = path == null ? '' : String(path);
  if (suffix === '') {
    return origin;
  }
  if (/^https?:\/\//i.test(suffix)) {
    return suffix;
  }
  const normalizedPath = suffix.startsWith('/') ? suffix : `/${suffix}`;
  return `${origin}${normalizedPath}`;
}

export const API_BASE_URL = resolveApiBaseUrl();
